/* import __COLOCATED_TEMPLATE__ from './legal-disclaimer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();